/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PlaceholderSpinner from 'components/kea/placeholders/PlaceholderSpinner';
import PlaceholderError from 'components/kea/placeholders/PlaceholderError';
import DashboardStub from 'components/kea/DashboardStub';
import { getAnalyticsWidgetsPerformance } from 'actions';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import PagePerformanceBlock from './PagePerformanceBlock';
import styles from './WidgetPerformance.module.scss';

const MainSection = () => {
  const dispatch = useDispatch();
  const localizeMessage = useLocalizedMessage();
  const { analytics: { recs, timeframe }, app: { currentShop } } = useSelector(store => store);
  const { widgetsPerformance: { isFetching, pages, error } } = recs;

  useEffect(() => {
    dispatch(getAnalyticsWidgetsPerformance(currentShop, timeframe));
  }, [timeframe, currentShop]);

  const sortedPages = [...(pages || [])]
    .sort((left, right) => (
      (right.counters?.view || 0) - (left.counters?.view || 0)
      || (right.counters?.show || 0) - (left.counters?.show || 0)
    ));

  if (isFetching) return <PlaceholderSpinner height={360} />;
  if (error) return <PlaceholderError error={error} height={360} />;

  if (sortedPages.length === 0) {
    return (
      <section className={styles.emptyCard} data-testid="recommendation-widget-analytics-empty">
        <div className={styles.sectionHeader}>
          <h2>{localizeMessage('recs.analytics.widgetsPerformance.header')}</h2>
          <p>{localizeMessage('recs.analytics.widgetsPerformance.hint')}</p>
        </div>
        <DashboardStub variant="line" messageId="recs.analytics.widgetsPerformance.empty" />
      </section>
    );
  }

  return (
    <div className={styles.pageList} data-testid="recommendation-widget-analytics">
      {sortedPages.map((page, index) => (
        <section
          className={styles.pageCard}
          key={page.data?.id || page.data?.title || index}
          data-testid="recommendation-widget-page"
        >
          <div className={styles.sectionHeader}>
            <div>
              <h2>{page.data?.title || localizeMessage('recs.analytics.widgetsPerformance.untitledPage')}</h2>
              <p>{localizeMessage('recs.analytics.widgetsPerformance.hint')}</p>
            </div>
            <span className={styles.widgetCount}>
              {localizeMessage('recs.analytics.widgetsPerformance.widgetCount', {
                count: page.widgets?.length || 0,
              })}
            </span>
          </div>
          {page.widgets?.length ? (
            <PagePerformanceBlock page={page} />
          ) : (
            <DashboardStub compact variant="line" messageId="recs.analytics.widgetsPerformance.emptyPage" />
          )}
        </section>
      ))}
    </div>
  );
};

export default MainSection;
